function Navigation(element) {
  this.$element = $(element);

  this.selectors = {
    sortContainer: '.js-sort-container',
    modifierHamburger: '.c-navigation--hamburger',
    navigationList: '.c-navigation__list',
    sublistTogglers: '.c-navigation__sublist_toggler',
    body: 'body'
  };

  this.data = {
    pluginName: 'plugin-name',
    constraint: 'sort-constraint'
  };

  this.init = function () {
    this.$sortContainer = this.$element.find(this.selectors.sortContainer);
    if (this.$sortContainer.length) {
      this.initSort();
    }

    this.hasHamburger = this.$element.is(this.selectors.modifierHamburger);
    if (this.hasHamburger) {
      this.initHamburger();
    }

    this.$sublistTogglers = this.$element.find(this.selectors.sublistTogglers);
    if (this.$sublistTogglers.length > 0) {
      this.initSublistTogglers();
    }
  };

  /**
   * collapse all navigations into the hamburger menu on mobile
   * you can use the modifier --nocollapse on any navigation to exclude it from collapsing into the hamburger, see e.g. avidec-website-2019 project
   */
  this.initHamburger = function () {
    // create navigation panel
    this.mobileNavigationContainer = $('<div></div>').addClass('c-navigation--mobile');

    $(this.selectors.navigationList).each((function (i, item) {
      if (!$(item).closest('.c-navigation').hasClass('c-navigation--nocollapse')) {
        // remove id attributes
        var clonedHTML = $(item).clone();
        clonedHTML.find('[id]').removeAttr('id');

        this.mobileNavigationContainer.append(clonedHTML);
      }
    }).bind(this));
    $(this.selectors.body).prepend(this.mobileNavigationContainer);

    // create hamburger icon
    this.hamburgerContainer = $('<div></div>').addClass('c-navigation__hamburger');
    var hamburgerButton = $('<div></div>').
    addClass('c-navigation__hamburger-button').
    append('<span></span>').
    append('<span></span>').
    append('<span></span>');

    hamburgerButton.on('click', this.$onHamburgerClick.bind(this));
    this.$element.prepend(this.hamburgerContainer.append(hamburgerButton));

    // inject the hambuger icon into navigation as well
    this.mobileHamburgerContainer = $('<div></div>').addClass('c-navigation__hamburger');
    var navHamburgerButton = hamburgerButton.clone();
    navHamburgerButton.on('click', this.$onHamburgerClick.bind(this));
    $('.c-navigation--mobile').prepend(this.mobileHamburgerContainer.append(navHamburgerButton));

  };

  this.$onHamburgerClick = function () {
    $('body').toggleClass('c-navigation--shown');
    this.mobileNavigationContainer.toggleClass('c-navigation--shown');
    this.hamburgerContainer.toggleClass('c-navigation__hamburger--open');
    this.mobileHamburgerContainer.toggleClass('c-navigation__hamburger--open');
  };

  this.initSort = function () {
    this.dataPluginName = this.$element.data(this.data.pluginName);
    this.dataConstraint = this.$element.data(this.data.constraint);

    i4_Sort.factory(this.$sortContainer, 'js=' + this.dataPluginName).
    set_handles('js-navigation-handle').
    set_constraint(this.dataConstraint);
  };

  this.initSublistTogglers = function () {
    var me = this;
    this.$sublistTogglers.each(function (index, sublistToggler) {
      $(sublistToggler).unbind('click');
      $(sublistToggler).on('click', me.$onSublistTogglerClick).bind(me);
    });
  };

  this.$onSublistTogglerClick = function (event) {
    const $toggler = $(event.target);
    const $sublist = $(event.target).next();
    if ($sublist) {
      if ($sublist.hasClass('toggled')) {
        $sublist.removeClass('toggled');
        $toggler.removeClass('toggled');
      } else {
        $sublist.addClass('toggled');
        $toggler.addClass('toggled');
      }
    }
  };
}
